import {
  getEraseNodeInScene,
  isEraseCustomJudgeAreas,
  isEraseCustomJudgeAreasNode,
  isEraseNode,
} from '@ps/bridge/qc/base'
import store from '@ps/store'
import { libTabNameList } from '@ps/store/workbench/resource-manager/config'
// import nodePool from '@ps/bridge/qc/node-pool'
import { resetSplitProp } from '@ps/views/workbench/layer-manager/layer'
import { EventBus, Event } from '@ps/utils/event-bus'
import qc, { Texture } from 'qc'
import { categoryList } from '@ps/store/workbench/resource-manager/config'
import {
  isImage,
  isSequenceFrame,
  isEraseBrushImages,
  isEraseBrushCategory,
} from '@ps/bridge/qc/base'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { scripts } from '@ps/bridge/qc/scripts'
import { EraseType } from '@ps/workbench/undo-redo/module/erase'
import i18n from '@ps/lang'

export async function addEraseGroup(data: {
  name: string
  erase_switch: boolean
}) {
  const eraseNode = getEraseNodeInScene(
    store.state.workspace.game.sceneManager.currentSceneNode,
  )
  if (eraseNode) {
    const newGroup = await store.dispatch('workspace/game/addGroup', {
      nodes: [],
      targetNode: eraseNode,
      index: eraseNode.children.length - 3,
    })
    if (data) {
      newGroup.name = data.name
      // 增加组脚本
      const eraseGroupScript = newGroup.addScript(scripts.eraseGroup.name)
      eraseGroupScript.eraseGroupType = EraseType.CUSTOM_LAYER
      eraseGroupScript.canErase = data.erase_switch
      const eraseScriptData = eraseNode.getScript(scripts.erase.name)
      eraseScriptData.customLayerGroup.push(newGroup)
      eraseGroupScript.isEnableEraseable = data.erase_switch
    }
    EventBus.$emit(Event.REFRESHLAYER)
    resetSplitProp(newGroup)
  }
}

/** 擦除资源类型 */
export enum EraseResourceType {
  BrushCategory = 'brushCategory', // 笔触样式
  BrushImage = 'brushImages', // 跟手图片
  LayerResource = 'layerResource', // 图层资源
}

export enum EraseSettingTab {
  Design = 'design', // 外观
  Animation = 'animation', // 动画
}

export const eraseMaskSwitch = [
  {
    label: i18n.t('workbench.erase.layer.eraseable'),
    value: true,
  },
  {
    label: i18n.t('workbench.erase.layer.uneraseable'),
    value: false,
  },
]

// 擦除组件逻辑使用，判断是否资源节点
export function isResourceNode(node: qc.Node) {
  return isImage(node) || isSequenceFrame(node)
}

export function isMaskNode(node: qc.Node) {
  const eraseGroupData = node.getScript(scripts.eraseGroup.name)
  return eraseGroupData && Boolean(eraseGroupData.canErase)
  // return editorData
}

// 擦除组件非笔刷、跟手图片、自定义判定区域内的矩形图层资源
export function isNormalEraseLayer(node: qc.Node) {
  const parent = node.parent
  return (
    !isEraseNode(node) &&
    !isEraseBrushImages(node) &&
    !isEraseBrushImages(parent) &&
    !isEraseBrushCategory(node) &&
    !isEraseBrushCategory(parent) &&
    !isEraseCustomJudgeAreas(node) &&
    !isEraseCustomJudgeAreasNode(parent)
  )
}

export function updateCurrentEraseCustomLayer(nodes: qc.Node[], type: string) {
  const eraseNode = getEraseNodeInScene(
    store.state.workspace.game.sceneManager.currentSceneNode,
  ) as qc.Node
  if (!eraseNode) return
  const eraseScriptData = eraseNode.getScript(scripts.erase.name)
  nodes.forEach((node) => {
    if (node) {
      if (type === 'add') {
        if (node.getScript(scripts.eraseGroup.name)) {
          eraseScriptData.customLayerGroup.push(node)
        }
      }
      if (type === 'remove') {
        eraseScriptData.customLayerGroup =
          eraseScriptData.customLayerGroup.filter(
            (item) => item.uuid !== node.uuid,
          )
      }
    }
  })
}

// 添加擦除组件资源
export function addEraseResource(config: {
  targetNode: qc.Node
  rename?: string
  callback: any
  type: EraseResourceType
}) {
  const eraseGroupScript = config.targetNode.getScript(scripts.eraseGroup.name)
  const isCanErase = eraseGroupScript && eraseGroupScript.canErase
  const isCanSequenceFrame = !isCanErase
  const data = {
    poolTabList: ['commonResource', 'resourcePool'],
    playComponentResource: true,
    currentTab: libTabNameList.COMMON,
    currentChildTab: '',
    rules: isCanSequenceFrame ? ['aImage', 'image'] : ['image'],
    ...config,
    targetNode: {
      uuid: config.targetNode.uuid,
    },
  }
  if (config.rename) {
    data.rename = config.rename
  }
  if (config.callback) {
    data.callback = config.callback
  }
  store.commit('workspace/resourceManager/closeLibDialog')
  store.commit('workspace/resourceManager/updatePoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: 'commonResource',
    action: 'add',
  })
  store.commit('workspace/resourceManager/moveLibDialogNextToRight')
}

// 更新擦除组件资源
export function updateEraseResource(node: qc.Node, callback: any) {
  const updateNode = node || store.state.workspace.game.activeNode
  const getCategory = (node: qc.Node) => {
    if (isImage(node)) {
      return categoryList.image.category
    } else if (isSequenceFrame(node)) {
      // 暂不支持序列帧节点资源替换
      return categoryList.aImage.category
    }
    return categoryList.image.category
  }
  const category = getCategory(updateNode)

  const onReplaced = () => {
    console.log('替换回调')
    //
    callback && callback()
  }
  const data = {
    targetNode: {
      uuid: node.uuid,
    },
  }
  store.commit('workspace/resourceManager/assignPoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: category,
    action: 'update',
    onReplaced,
  })
  store.dispatch('workspace/resourceManager/getComponents', {
    category: category,
  })
  store.commit('workspace/resourceManager/moveDialogToRight')
}

export function setMaskSwitch(node: qc.Node, val: boolean) {
  const eraseGroupData = node.getScript(scripts.eraseGroup.name)
  if (eraseGroupData) {
    eraseGroupData.isEnableEraseable = val
  }
}
